import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CustomerShell } from "@/components/CustomerShell";
import { RefundTracker } from "@/components/RefundTracker";
import { useLiveRefresh } from "@/lib/useLiveRefresh";
import { ChevronLeft, Loader2, Undo2 } from "lucide-react";

export default function MyRefunds() {
    const nav = useNavigate();
    const [rows, setRows] = useState(null);
    const load = () => api.get("/refunds/mine").then((r) => setRows(r.data)).catch(() => setRows([]));
    useEffect(() => { load(); }, []);
    useLiveRefresh(load);
    return (
        <CustomerShell>
            <div className="px-5 pb-28 pt-6">
                <button data-testid="refunds-back-btn" onClick={() => nav(-1)} className="mb-3 flex items-center gap-1 text-sm font-semibold text-navy/55"><ChevronLeft size={16} /> Back</button>
                <h1 className="font-heading text-2xl font-extrabold text-navy">My refunds</h1>
                <p className="text-sm text-navy/55">Track every refund step. You'll get a notification when it's approved and when the money is sent.</p>
                {rows === null && <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>}
                {rows?.length === 0 && (
                    <div data-testid="refunds-empty" className="mt-8 flex flex-col items-center rounded-2xl border border-navy/10 bg-white py-12 text-center text-sm text-navy/45"><Undo2 size={28} className="mb-2 opacity-40" /> No refunds yet.</div>
                )}
                <div className="mt-5 space-y-3">{rows?.map((r) => <RefundTracker key={r.id} r={r} />)}</div>
            </div>
        </CustomerShell>
    );
}
